<template>
    <div>
        <h2 class="card-title">조제/배송 내역 <span class="reserve-num">{{ notes.length }}</span></h2>
        <table border="0" cellpadding="0" cellspacing="0" width="100%" summary="전화 상담 리스트" class="consult-list reserve-list">
            <caption style="display: none;">조제/배송 내역</caption>
            <colgroup>
                <col width="30%">
                <col width="12%">
                <col width="*%">
                <col width="10%">
                <col width="10%">
            </colgroup>
            <thead>
                <tr>
                    <th>날짜</th>
                    <th>신청자</th>
                    <th>병원</th>
                    <th>수납</th>
                    <th>배송</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="note in notes" :key="note.note_id" @click="popup_detail(note)">
                    <!-- <td>{{ note.created_at }}</td> -->
                    <td>{{ note.created_at | date_format('YYYY-MM-DD (dd) HH:mm') }}</td>
                    <td>{{ set_substr(note.nickname,5) }}</td>
                    <td>{{ set_substr(note.dr_name,12) }}</td>
                    <td>{{ note.status >= 4 && note.status != 9 ? 'O':'X' }}</td>
                    <td>{{ note.status >= 6 && note.status != 9 ? 'O':'X' }}</td>
                </tr>
            </tbody>
        </table>
        <!-- 더보기 -->
        <p class="more" v-if="notes.length>0">조제/배송 내역 <a href="" @click.prevent="$router.push(`/consult-pharm`)">더보기</a></p>
        <p class="more" v-else> --- 내역이 없습니다 ---</p>
    </div>
    
</template>

<script>
// replyCount
// row_count

  import { mapState } from 'vuex'
  import { nameByConstMixin } from '@/lib/mixins'
//  import { ACCOUNT_TYPE, CONSULT_ACTION, STATUS_CODE, CONSULT_STATUS } from '@/lib/constants'

//  let interval_id = null
  export default {
    mixins: [ nameByConstMixin ],
    name: 'pharm-home',
//    props: ['dr_id'],
    data() {
      return {
        notes: []
        , note_type : 9
        , winPop: null
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
        popup_detail(note) {
            // let routeData = this.$router.resolve({path:`/consulttel_popup/${note.note_id}`, params:{status: note.status, consult_price_items: note.consult_price_items}});
            // this.popupCenter(routeData.href, "tel_detail", 590, 800, 0, 200);
            return;
        },
        async load_list () {
            // console.log("NoteHome : load_list()");
            let params = {
                pharm_id : this.account.pharm_id,
                note_type : this.note_type,
                //sort: 'created_at:desc',
                limit: 4
            };

            // console.log("/consult_note  params=>" , params);
            let {data} = await this.axios.get(`/consult_pharm`, {params: params})
            let {resp} = data

            // console.log("/consult_note response = ", data);
            if(data.status == "200"){
                //console.log(data);
                if(!resp.consults) {
                    this.notes = [];
                    //return;
                } else {
                    this.notes = resp.consults
                    this.is_paging = true;
                }
            } else {
                this.notes = [];
                //console.log(data);
            }
        },
        //   set_substr(str, str_len) {
        //     if(str.length>str_len) str = str.substr(0,str_len) + "...";
        //     return str;
        //   }
        },
        mounted () {
            // console.log("mounted");
            this.load_list()

        },
        beforeDestroy() {    
        }
    }
</script>

<style scoped>
    /* 홈카드 공통 */
    .card-title {
        float:left;
        color: #4c4c4c;
        position: relative;
        margin-bottom: 20px;
        font: 600 20px 'Noto Sans KR', sans-serif;
    }

    .more {
        color: #494949;
        text-align: center;
        letter-spacing: -.5px;
        margin-top: 15px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .more a {
        margin-left: 5px;
        color: #6e6fe5;
        font-weight: 600;
        text-decoration: underline;
    }

    /* 상담리스트 공통 */
    .consult-list {
        font: 400 14px/45px 'Noto Sans KR', sans-serif;
    }

    .consult-list thead {
        color: #999;
    }

    .consult-list tbody {
        color: #494949;
        text-align: center;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
    }

    .consult-list tbody td:nth-of-type(2) {
        color: #736ee6;
    }

    /* 상담 현황 */
    .reserve-num {
        color: #fff;
        padding: 4px 12px;
        border-radius: 15px;
        background-color: #736ee6;
        position: absolute;
        top: 3px;
        left: 135px;
        font: 600 14px 'Droid Serif', serif;
    }
    
    .reserve-list tbody td:nth-of-type(4) {
        vertical-align: middle;
    }

    .reserve-list .consult-chk {
        width: 16px;
        height: 16px;
        margin: 0 auto;
        cursor: pointer;
        border: 1px solid #dfdfdf;
    }

    .reserve-list tbody td:nth-of-type(4) input[type="checkbox"] {
        display: none;
    }

    .reserve-list tbody td:nth-of-type(4) input[type="checkbox"]:checked + .consult-chk {
        border-color: #736ee6;
        background: url(../../assets/home/checked.png) center center/14px no-repeat;
    }

    .consult-enter {
        color: #fff;
        border: none;
        outline: 0;
        cursor: pointer;
        padding: 7px 25px;
        border-radius: 25px;
        background-color: #736ee6;
    }

    /* 버튼그룹(라디오) */
    .btn-group {
        overflow:hidden;
        margin-bottom: 15px;
    }

    .btn-group .btn-radio {
        text-align:right;
        font-size: 0;
        margin-top: 5px;
    }

    .btn-group .btn-radio > li {
        color: #aeafb3;
        margin-left: 15px;
        display: inline-block;
    }

    .consult-complete-radio {
        display: block;
        text-indent: 26px;
        cursor: pointer;
        position: relative;
        font: 400 15px 'Noto Sans KR', sans-serif;
    }

    .consult-complete-radio::before {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #ddd;
        box-sizing: border-box;
        background-color: #fff;
        position: absolute;
        left: 0;
        top: 2px;
    }

    .btn-group .btn-radio input[type="radio"] {
        display: none;
    }

    .btn-group .btn-radio input[type="radio"]:checked + .consult-complete-radio::before {
        border: 3px solid #736ee6;
    }
/* 버튼그룹(라디오) END */
</style>